<template>
  <v-dialog
    persistent
    v-model="selectedOpen"
    :activator="selectedElement"
    width="500"
  >
    <v-card :class="`${arabic ? 'arFont' : 'enFont'}`">
      <v-card-title class="text-h5 grey lighten-2">
        {{ i18n.appointment_details }}
      </v-card-title>

      <v-card-text>
        <appointmentDialogDetails :selectedEvent="selectedEvent" />
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="$emit('close')"
        >
          {{ i18n.close }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import appointmentDialogDetails from '@/components/appointmentDialogDetails'

export default {
  components: {
    appointmentDialogDetails
  },
  props: ['selectedOpen', 'selectedElement', 'selectedEvent'],
	computed: {
		user() {
			return this.$store.state.user
		},
		language() {
			return this.$store.state.language
		},
		i18n() {
			return this.$store.state.i18n[this.$store.state.language]
		},
		arabic() {
			if (this.$store.state.language == 'ar') return true
		},
	},
}
</script>